export default __webpack_public_path__ + "static/media/benjamincode.31efe929.webp";